<label for="traffic-options">Options</label>
<div class="traffic-options" id="traffic-options">
  @for (option of optionData; track trackByFn(i); let i = $index) {
      <app-route-planner-option [optionModel]='option' [isImageLogo]='true' [optionId]='i'
      (onOptionSelected)='updateCheckedOptions()'></app-route-planner-option>
  }
</div>
